import styled from 'styled-components'

import { palette } from '_styles/variables'

export const TdDiv = styled.div`
  height: 2.75rem;
  display: flex;
  font-size: 0.875rem;
  align-items: center;
`

export const DataDiv = styled(TdDiv)`
  width: 18.5625rem;
`

export const EllipsisDiv = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const KeyDiv = styled(TdDiv)`
  width: 8.1875rem;
  font-weight: 600;
  color: ${palette.neutral['grey-icons']};
`
